import { useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { clsx } from 'clsx';
import { UTP } from './constants';

export const Utp: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['list']}>
        {UTP.map(({ title, description, imageClass }, index) => (
          <div key={index} className={styles['item']}>
            <div className={clsx(styles['image'], styles[imageClass])} />
            <div className={styles['title']}>{title}</div>
            <div className={styles['description']}>{description}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
